import { regular_xs } from '@components/web/texts/Styles';
import { twMerge } from 'tailwind-merge';
import ReactDOMServer from 'react-dom/server';

/**
 * Helper function which creates tooltip markup for a given text.
 *
 * @param inner
 * @returns
 */
export function Tooltip(
  inner = `<span>Press</span><span class="border-2 border-product-text-primary-dark rounded p-0.5">Esc</span>`,
  className?: string,
) {
  return `<div class="${twMerge('flex space-x-1 drop-shadow-md text-xs leading-3 items-center justify-center text-product-text-primary-dark bg-product-background-secondary-dark border-2 border-product-line-secondary-dark border-transparent font-normal p-2 rounded-md', className)}">
      ${inner}
    </div>
  `;
}

export function DefaultTooltip(text: string, className?: string) {
  return `<div class="${twMerge(
    `bg-product2-background-tertiary text-product2-content-primary py-2 px-3 rounded-lg text-center text-pretty ${regular_xs}`,
    className,
  )}">${text}</div>`;
}

export function DefaultTooltipWithIcon(
  text: string,
  icon: React.ReactElement,
  className?: string,
) {
  return `<div class="${twMerge(
    `flex items-center space-x-2 bg-product2-background-tertiary text-product2-content-primary py-2 px-3 rounded-lg text-center text-pretty ${regular_xs}`,
    className,
  )}">${ReactDOMServer.renderToStaticMarkup(icon)}<span>${text}</span></div>`;
}
